import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";

const AutoTest = () => {
    const screenId="AutoTest"
    const formatters = Formatters()
    const charts = {
                "sleep.10.502": {
                    source: "test"
                },
                "sleep.5.404": {
                    source: "test"
                },
                "sleep.120.200": {
                    source: "test"
                }

    }
    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default AutoTest
